import React, { useEffect } from 'react';
import { getStaticBaseUrl } from '../../stores/configStore';
import useGroupsStore from '../../stores/groupsStore';

const groups = [
  { id: 1, name: '9-ТЗИ-21', students: [
    { id: 1, name: 'Иванов Иван' },
    { id: 2, name: 'Петров Петр' },
  ]},
  { id: 2, name: '10-ИТ-22', students: [
    { id: 3, name: 'Сидоров Сидор' },
    { id: 4, name: 'Кузнецов Кузьма' },
  ]},
];

const fakeFiles = [
  { id: 1, name: 'Домашка.pdf', userId: 1 },
  { id: 2, name: 'Ответы.docx', userId: 2 },
  { id: 3, name: 'Решение.png', userId: 1 },
];

function getGroupName(groupId) {
  const group = groups.find(g => String(g.id) === String(groupId));
  return group ? group.name : '';
}
function getStudentName(groupId, studentId) {
  const group = groups.find(g => String(g.id) === String(groupId));
  if (!group) return '';
  const student = group.students.find(s => String(s.id) === String(studentId));
  return student ? student.name : '';
}
function getGroupStudents(groupId) {
  const group = groups.find(g => String(g.id) === String(groupId));
  return group ? group.students : [];
}

function AdminSlotDetailsModal({ open, onClose, slot }) {
  const { groups, fetchGroups } = useGroupsStore();
  useEffect(() => { fetchGroups(); }, [fetchGroups]);
  if (!open || !slot) return null;

  const students = slot.studentId ? [
    { id: slot.studentId, name: getStudentName(slot.groupId, slot.studentId) }
  ] : getGroupStudents(slot.groupId);

  const filesByStudent = students.map(s => ({
    ...s,
    files: fakeFiles.filter(f => String(f.userId) === String(s.id)),
  }));

  return (
    <div className="modal-overlay admin-slot-details-modal-overlay">
      <div className="modal-content admin-slot-details-modal-content">
        <div className="admin-slot-details-modal-header">
          <h2>Детали занятия</h2>
          <button onClick={onClose} className="admin-slot-details-modal-close">&times;</button>
        </div>
        <div className="admin-slot-details-modal-info">
          <div className="admin-slot-details-modal-time">{slot.timeLabel}</div>
          <div className="admin-slot-details-modal-subject">{typeof slot.subject === 'object' && slot.subject !== null ? slot.subject.name : slot.subject}</div>
        </div>
        <div className="admin-slot-details-modal-meta">
          <div><b>Группа:</b> {(() => {
            // Предпочитаем объект из slot.group или slot.groupId
            if (slot.group && typeof slot.group === 'object') return slot.group.name || '';
            if (slot.groupId && typeof slot.groupId === 'object') return slot.groupId.name || '';
            // Если пришёл только id — найдём имя в сторе групп
            const id = slot.groupId || slot.group;
            const found = groups.find(g => String(g._id) === String(id));
            return found ? found.name : '';
          })()}</div>
          {slot.studentId && <div><b>Ученик:</b> {slot.studentId}</div>}
        </div>
        <div style={{ margin: '8px 0 16px' }}>
          <button onClick={() => {
            // Переход на страницу посещаемости этого слота
            const dateStr = slot.date || (slot.currentDate ? slot.currentDate.toISOString().slice(0,10) : '');
            const id = slot.scheduleId;
            if (!id) {
              // Попытка взять id из props slot.group / student контекста AdminRasp
              const fallbackId = slot?.schedule?._id || slot?.group?._id || '';
              if (!fallbackId) {
                alert('Не удалось определить занятие. Закройте окно, сохраните слот и попробуйте снова.');
                return;
              }
              window.location.href = `/admin/attendance/slot?scheduleId=${fallbackId}`;
              return;
            }
            window.location.href = `/admin/attendance/slot?scheduleId=${id}`;
          }} className="admin-slot-details-go-attendance" style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #E0E0E6', background: '#fff' }}>Перейти к посещаемости</button>
        </div>
        {slot.comment && <div className="admin-slot-details-modal-comment"><b>Комментарий:</b> {slot.comment}</div>}
        <div className="admin-slot-details-modal-files-title">Файлы, прикреплённые к этому слоту</div>
        <div className="admin-slot-details-modal-files-list-wrapper">
          {slot.attachments && slot.attachments.length > 0 ? (
            Object.entries(
              slot.attachments.reduce((acc, f) => {
                const user = f.user && f.user.fullName ? f.user.fullName : 'Неизвестный пользователь';
                if (!acc[user]) acc[user] = [];
                acc[user].push(f);
                return acc;
              }, {})
            ).map(([user, files]) => (
              <div key={user} className="admin-slot-details-modal-user-files">
                <div className="admin-slot-details-modal-user">{user}:</div>
                <ul className="admin-slot-details-modal-file-list">
                  {files.map((f, i) => (
                    <li key={f.fileUrl + i} className="admin-slot-details-modal-file-item">
                      {f.fileName && /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName) ? (
                        <img src={`${getStaticBaseUrl()}${f.fileUrl}`} alt={f.fileName} className="admin-slot-details-modal-file-img" />
                      ) : (
                        <span className="admin-slot-details-modal-file-icon">📎</span>
                      )}
                      <div className="admin-slot-details-modal-file-info">
                        <a href={`${getStaticBaseUrl()}${f.fileUrl}`} target="_blank" rel="noopener noreferrer" className="admin-slot-details-modal-file-link">{f.fileName}</a>
                        <div className="admin-slot-details-modal-file-date">{f.uploadedAt ? new Date(f.uploadedAt).toLocaleString() : ''}</div>
                        {f.comment && <div className="admin-slot-details-modal-file-comment">Комментарий: {f.comment}</div>}
                      </div>
                      <a href={`${getStaticBaseUrl()}${f.fileUrl}`} download className="admin-slot-details-modal-file-download">Скачать</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          ) : (
            <div className="admin-slot-details-modal-no-files">Нет файлов</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminSlotDetailsModal; 